import type { ExtractPropTypes } from 'vue'
import { datePickerProps as elDatePickerProps } from 'element-plus'
import type { DatePickerProps as ElDatePickerProps } from 'element-plus'
import { useLocale } from '@el-plus/hooks/use-locale'
const { t } = useLocale()
export const datePickerRangeProps = {
  ...elDatePickerProps,
  type: {
    ...elDatePickerProps.type,
    default: 'daterange',
  },
  valueFormat: {
    ...elDatePickerProps.valueFormat,
    default: 'x',
  },
  shortcuts: {
    ...elDatePickerProps.shortcuts,
    default: () => {
      return [
        {
          text: t('ep.datePickerRange.lastWeek'),
          value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            return [start, end]
          },
        },
        {
          text: t('ep.datePickerRange.lastMonth'),
          value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            return [start, end]
          },
        },
        {
          text: t('ep.datePickerRange.lastThreeMonth'),
          value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            return [start, end]
          },
        },
      ]
    },
  },
  rangeSeparator: {
    ...elDatePickerProps.rangeSeparator,
    default: '~',
  },
  startPlaceholder: {
    ...elDatePickerProps.startPlaceholder,
    default: () => {
      return t('ep.datePickerRange.startTime')
    },
  },
  endPlaceholder: {
    ...elDatePickerProps.endPlaceholder,
    default: () => {
      return t('ep.datePickerRange.endTime')
    },
  },
  size: {
    ...elDatePickerProps.size,
    default: 'default',
  },
} as const
export type DatePickerRangeProps = ExtractPropTypes<typeof datePickerRangeProps>
export const datePickerRangeEmits = {}
export type DatePickerRangeEmits = typeof datePickerRangeEmits
